// import Joi from 'joi-browser';
import HttpService from '@pingum/api-services/HttpService';

export default class EventTemplateReminderService {
  static deleteEventTemplateReminder(id) {
    if (!id) {
      return Promise.reject(new Error('Missing Task Reminder ID'));
    }

    return this.httpService.delete(`/${id}`);
  }

  static updateEventTemplateReminder(id, request) {
    if (!id) {
      return Promise.reject(new Error('Missing Task Reminder ID'));
    }

    return this.httpService.patch(`/${id}`, request);
  }

  static getEventTemplateReminders() {
    return this.httpService.get('');
  }

  static getEventTemplateReminderTagReminders(id) {
    return this.httpService.get(`/${id}/tagReminders`);
  }
}

EventTemplateReminderService.httpService = new HttpService({
  baseURL: `${typeof window !== 'undefined'
    ? env.REACT_APP_EVENT_API
    : ''}/eventTemplateReminders`,
});
